module.exports = __webpack_public_path__ + "static/media/mgpre2.37c425a8.png";